"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTMDBData = void 0;
var react_1 = require("react");
var extractIMDbId_1 = require("./extractIMDbId");
var tmdbApi_1 = require("./tmdbApi");
var dataEnrichmentPrefs_1 = require("./dataEnrichmentPrefs");
var cache = new Map();
var CACHE_DURATION = 24 * 60 * 60 * 1000;
var getCachedData = function (key) {
    var cached = cache.get(key);
    if (cached && Date.now() - cached.timestamp < CACHE_DURATION) {
        return cached.data;
    }
    return null;
};
var setCachedData = function (key, data) {
    cache.set(key, { data: data, timestamp: Date.now() });
};
var useTMDBData = function (metaItem) {
    var _a = (0, react_1.useState)(null), data = _a[0], setData = _a[1];
    var _b = (0, react_1.useState)(false), loading = _b[0], setLoading = _b[1];
    var _c = (0, react_1.useState)(null), error = _c[0], setError = _c[1];
    var imdbId = (0, react_1.useMemo)(function () { return (0, extractIMDbId_1.extractIMDbId)(metaItem); }, [metaItem]);
    var apiKey = (0, react_1.useMemo)(function () { return (0, tmdbApi_1.getTMDBApiKey)(); }, []);
    var showSimilarTitles = (0, dataEnrichmentPrefs_1.useDataEnrichmentPrefs)().showSimilarTitles;
    (0, react_1.useEffect)(function () {
        if (!imdbId || !apiKey) {
            setData(null);
            setLoading(false);
            setError(null);
            return;
        }
        var determineType = function () {
            if ((metaItem === null || metaItem === void 0 ? void 0 : metaItem.type) === 'series' || (metaItem === null || metaItem === void 0 ? void 0 : metaItem.type) === 'tv') {
                return 'tv';
            }
            return 'movie';
        };
        var type = determineType();
        var cacheKey = "".concat(imdbId, ":").concat(type, ":").concat(showSimilarTitles ? '1' : '0');
        var cached = getCachedData(cacheKey);
        if (cached) {
            setData(cached);
            setLoading(false);
            setError(null);
            return;
        }
        setLoading(true);
        setError(null);
        (0, tmdbApi_1.getTMDBData)(imdbId, apiKey, type, { includeCollectionParts: showSimilarTitles })
            .then(function (result) {
            if (result) {
                setCachedData(cacheKey, result);
                setData(result);
            }
            else {
                setData(null);
            }
            setLoading(false);
        })
            .catch(function (err) {
            setError(err.message || 'Failed to fetch TMDB data');
            setLoading(false);
            setData(null);
        });
    }, [imdbId, apiKey, metaItem, showSimilarTitles]);
    return { data: data, loading: loading, error: error };
};
exports.useTMDBData = useTMDBData;
